module.exports = __webpack_public_path__ + "static/media/banner-original.00f81847.png";